import React from 'react';
import { ButtonV2 } from 'components';
import { ButtonSize } from 'constants/button';
import {} from './ModalBodyButtons.types';
export const ModalSaveButton = ({ onSaveChanges }) => (React.createElement(ButtonV2, { id: "save-button", onClick: onSaveChanges, size: ButtonSize.MEDIUM, type: "button" }, "Save changes"));
export const ModalKeepWorkingButton = ({ onClose }) => (React.createElement(ButtonV2, { id: "save-button", onClick: onClose, size: ButtonSize.MEDIUM, type: "button" }, "Keep working"));
